import { render, staticRenderFns } from "./MeetingDesktop.vue?vue&type=template&id=8e52cf18&scoped=true"
import script from "./MeetingDesktop.vue?vue&type=script&lang=js"
export * from "./MeetingDesktop.vue?vue&type=script&lang=js"
import style0 from "./MeetingDesktop.vue?vue&type=style&index=0&id=8e52cf18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e52cf18",
  null
  
)

export default component.exports